// BACKEND_URL = "http://localhost:2000";

const BACKEND_URL = "https://recipeserver-96hb.onrender.com";

export { BACKEND_URL };
